function show_company_name_field() {
  const is_company = $('input[name="user[company]"]:checked').val() == '1'
  if (is_company) {
    $('#company_name').show()
  } else {
    $('#company_name').hide()
  }
}

$(document).ready(function() {
  show_company_name_field()
  $('input[name="user[company]"]').change(function() {
    show_company_name_field()
  })
})
